/** 校验用户数量 */
export function validateUserCount (rule, value, callback) {
  if (!value || value.length <= 0) {
    callback(new Error(`请先选择面向人员`));
  } else {
    callback();
  }
}

/** 校验用户数量 */
export function validateUser (rule, value, callback) {
  if (!(!!value)) {
    callback(new Error(`请输入最大客户数`))
  } else if (!/^[0-9]{0,6}$/.test(value)) {
    callback(new Error(`最大客户数为最大999999的整数`))
  } else {
    callback()
  }
}

/** 校验数量 */
export function validateNum (rule, value, callback) {
  if (!(!!value)) {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^[0-9]{0,4}$/.test(value)) {
    callback(new Error(`${rule.name}为最大9999的整数`))
  } else {
    callback()
  }
}
/** 校验数量1-9999 */
export function validateNum1 (rule, value, callback) {
  if (!value || value == '') {
    callback()
  }else if (!/^\d{1,4}$/.test(value)) {
    callback(new Error(`请输入1-9999的整数`))
  } else if (Number(value) < 1 || Number(value) > 9999) {
    callback(new Error(`请输入1-9999的整数`))
  } else {
    callback()
  }
}
/** 校验数量正整数 */
export function validateNum2 (rule, value, callback) {
  if (!(!!value)) {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^[0-9]+$/.test(value)) {
    callback(new Error(`请输入正确的正整数`))
  } else {
    callback()
  }
}
/** 校验客户上线选中用户 */
export function validateChecked (rule, value, callback) {
  if (!(!!value)) {
    callback(new Error(`请选择${rule.name}`))
  } else if (value.length <= 0) {
    callback(new Error(`请选择${rule.name}`))
  } else {
    callback()
  }
}